import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
} from 'antd'
import { firestore } from '../../../service/firebase'
import './TownTrivia.scss'


export default class TownTrivia extends React.Component {
    
    columns = [
        { title: "Question", dataIndex: 'title', key: 'title' },
        { title: "Answer A", dataIndex: 'a', key: 'a' },
        { title: "Answer B", dataIndex: 'b', key: 'b' },
        { title: "Answer C", dataIndex: 'c', key: 'c' },
        { title: "Correct Answer", dataIndex: 'answer', key: 'answer', render: answer => {
            console.log(answer)
            return <div>Answer {answer.toUpperCase()}</div>
        } },
        { title: 'Actions', dataIndex: '', key: 'action', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleEdit(item)}>Edit</a>
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []
    
    state = {
        showModal: false,
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('Trivia')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            id: '',
            title: '',
            a: '',
            b: '',
            c: '',
            answer: '',
            showModal: true,
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        let state = this.state

        let newState = Object.assign(state, item, {
            showModal: true,
        })

        console.log(newState)
        this.setState(newState)
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('Trivia').doc(item.id).delete();
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('Trivia').doc()
            id = ref.id
        } else {
            ref = firestore.collection('Trivia').doc(id)
        }

        let object = {
            id,
            title: state.title ? state.title : '',
            a: this.safeValue(state.a),
            b: this.safeValue(state.b),
            c: this.safeValue(state.c),
            answer: this.safeValue(state.answer),
        }

        console.log(object)

        ref.set(object)
        this.setState({showModal: false})
    }

    safeValue(text) {
        return text ? text : ''
    }

    link(text) {
        if(text.substring(0, 4) === 'http') {
            return text
        } else {
            return 'http://' + text
        }
    }

    handleClose() {
        this.setState({showModal: false})
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
   
    render() {

        return (
            <div className="trivia">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Town Trivia</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                
                <Modal
                    title={this.eventEdit ? 'Edit Town Trivia' : "Add Town Trivia"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleClose()}>

                    <Row className="input-row">
                        <div className="input-label">Question</div>
                        <Input value={this.state.title} onChange={evt => this.handleChange('title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Answer A</div>
                        <Input value={this.state.a} onChange={evt => this.handleChange('a', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Answer B</div>
                        <Input value={this.state.b} onChange={evt => this.handleChange('b', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Answer C</div>
                        <Input value={this.state.c} onChange={evt => this.handleChange('c', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Correct Answer</div>
                        <Input value={this.state.answer} onChange={evt => this.handleChange('answer', evt.target.value)} />
                    </Row>

                </Modal>

            </div>
        )
    }
}
